<script>
    import Spinner from '../../components/Spinner.svelte';
	import UnathContext from '../../layouts/UnathContext.svelte';
	import { navigate } from 'svelte-routing';
	import queryString from 'query-string';
	import firebase from '../../firebase';

	let email = queryString.parse(window.location.search).email;
	let message;
    let promise;

	const sendReset = () => {
		message = null;
		promise = firebase.auth()
			.sendPasswordResetEmail(email)
			.then(() => message = { type: 'success', text: 'Email sent successfully.' })
			.catch(error => message = { type: 'error', text: error.message });
	}
</script>

<UnathContext title="Reset password" on:enterPressed={sendReset}>
	<div class="modal">
		<div class="modal__box modal__box--sm">
			<div class="modal__header">
				Reset password
			</div>
			<div class="modal__body layout">
				<div class="layout__column">
					<div class="layout__item">
						<input class="form__input" type="text" placeholder="Email" bind:value={email} />
					</div>
					{#if message}
						<div class="layout__item {message.type}-message">{message.text}</div>
					{/if}
					<div class="layout__row layout__row--collapsable layout__row--space-between">
						<div class="layout__item">
							<div
								class="form__button form__button--subtle"
								on:click={() => navigate(`/auth/sign-in${email ? `?email=${encodeURIComponent(email)}` : ''}`)}>
								Return to sign in
							</div>
						</div>
						<div class="layout__row layout__row--right">
							<div class="layout__item">
								{#await promise}
									<div class="form__button form__button--disabled"><Spinner />Send reset link</div>
								{:then result}
									<div class="form__button" on:click={sendReset}>Send reset link</div>
								{/await}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</UnathContext>